<section-info></section-info>
<div *ngIf="showimport && documentType">
  <finanzplan-document [documentType]="documentType" [finanzplanDocumentId]="finanzplanDocumentId"
    (documentUploaded)="onDocumentUploaded($event)" [formGroup]="financeDataForm"></finanzplan-document>
</div>

<form [formGroup]="financeDataForm">
  <div class="finance-form">
    <div>
      <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [for]="personalmittel"
            text="{{getFieldLabelByBerechnungsmethode('finance-data.personellcost') | translate}}"
            [infotooltip]="'finanzdaten.personalkosten'"></kendo-label>
        <kendo-numerictextbox formControlName="personalmittel" #personalmittel [autoCorrect]="true" [min]="0"
          [format]="currencyFormatOptions" [appinfotext]="'finanzdaten.personalkosten'"
          [spinners]="false"></kendo-numerictextbox>
      </kendo-formfield>

      <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [for]="sachmittel"
            text="{{getFieldLabelByBerechnungsmethode('finance-data.materialcost') | translate}}"
            [infotooltip]="'finanzdaten.sachkosten'"></kendo-label>
        <kendo-numerictextbox formControlName="sachmittel" #sachmittel [autoCorrect]="true" [min]="0"
          [format]="currencyFormatOptions" [appinfotext]="'finanzdaten.sachkosten'" [spinners]="false">
        </kendo-numerictextbox>
      </kendo-formfield>

      <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [for]="investitionsmittel"
            text="{{getFieldLabelByBerechnungsmethode('finance-data.investmentcost') | translate }}"
            [infotooltip]="'finanzdaten.investitionskosten'"></kendo-label>
        <kendo-numerictextbox formControlName="investitionsmittel" #investitionsmittel [autoCorrect]="true" [min]="0"
          [format]="currencyFormatOptions" [appinfotext]="'finanzdaten.investitionskosten'" [spinners]="false">
        </kendo-numerictextbox>
      </kendo-formfield>
    </div>
    <div>
      <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [for]="eigenmittel"
            text="{{ getFieldLabelByBerechnungsmethode('finance-data.equitycapital') | translate }}"
            [infotooltip]="'finanzdaten.eigenmittel'"></kendo-label>
        <kendo-numerictextbox formControlName="eigenmittel" #eigenmittel [autoCorrect]="true" [min]="0"
          [format]="currencyFormatOptions" [appinfotext]="'finanzdaten.eigenmittel'" [spinners]="false">
        </kendo-numerictextbox>
      </kendo-formfield>

      <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [for]="drittmittel"
            text="{{ getFieldLabelByBerechnungsmethode('finance-data.thirdPartyFunds') | translate }}"
            [infotooltip]="'finanzdaten.drittmittel'"></kendo-label>
        <kendo-numerictextbox formControlName="drittmittel"  #drittmittel [autoCorrect]="true" [min]="0"
          [format]="currencyFormatOptions" [appinfotext]="'finanzdaten.drittmittel'" [spinners]="false">
        </kendo-numerictextbox>
      </kendo-formfield>
    </div>
  </div>
  <div [class]="reverseCalculationRow ? 'display-form-reverse' : 'display-form'">
    <kendo-formfield class="foerdersumme">
      <kendo-label class="form-label" [for]="foerdersumme"
          text="{{getFieldLabelByBerechnungsmethode('finance-data.requestedFunding') | translate}}"
          [infotooltip]="'finanzdaten.angefragtefoerdersumme'"></kendo-label>
      <kendo-numerictextbox [readonly]="isFoerdersummeDisabled" [format]="currencyFormatOptions"
        formControlName="foerdersumme" #foerdersumme [disabled]="isFoerdersummeDisabled" [autoCorrect]="true" [min]="0"
        [appinfotext]="'finanzdaten.angefragtefoerdersumme'" [spinners]="false">
      </kendo-numerictextbox>
    </kendo-formfield>
    <form [formGroup]="financeDataDisplayForm">
      <kendo-formfield class="gesamt">
        <kendo-label class="form-label" [for]="gesamt"
            text="{{getFieldLabelByBerechnungsmethode('finance-data.totalCost') | translate}}"
            [infotooltip]="'finanzdaten.gesamtkosten'"></kendo-label>
        <kendo-numerictextbox [readonly]="true" [format]="currencyFormatOptions" formControlName="gesamt" #gesamt
          [disabled]="true" [appinfotext]="'finanzdaten.gesamtkosten'" [spinners]="false">
        </kendo-numerictextbox>
      </kendo-formfield>
    </form>
  </div>
</form>

<bank-data-institution *ngIf="antragstellungFuerInstitution"
  [form]="financeDataForm.Institution"></bank-data-institution>

<bank-data-kontakt *ngIf="!antragstellungFuerInstitution" [form]="financeDataForm.Antragsteller"></bank-data-kontakt>